export default {"src":"https://s.sylndr.com/c-9cd064a/_next/static/media/buyCarIconEnabled.c5da2fb9.svg","height":20,"width":31,"blurWidth":0,"blurHeight":0};